module.exports = __webpack_public_path__ + "assets/img/00177.c7ea9c08.png";